<template>
  <div>
    <div :style="`height: ${confirm ? contentHeight : 'auto'};`" class="overflow--y">
      <div
        class="credit-card my-4"
        :class="[
          paymentMethod === 'CREDIT_CARD' && data.flag ? `card__${data.flag}` : null,
          { 'card--overlay': confirm },
          { 'card--yellow': paymentMethod === 'CREDIT_CARD' },
          { 'card--billet': paymentMethod === 'BOLETO' },
          { 'card--transfer': paymentMethod === 'BANK_TRANSFER' },
        ]"
      >
        <span v-if="paymentMethod === 'CREDIT_CARD'" class="card__name">
          {{ $t('Common.creditCard') }}
        </span>

        <span v-if="paymentMethod === 'BOLETO'" class="card__name">
          {{ $t('Common.billet') }}
        </span>

        <span v-if="paymentMethod === 'BANK_TRANSFER'" class="card__name">
          {{ $t('Common.transfer') }}
        </span>

        <div v-if="paymentMethod === 'CREDIT_CARD'" class="card--footer">
          <span>{{ data.holderName }}</span>
          <span class="card__number">{{ data.number }}</span>
          <span class="card__flag"></span>
        </div>

        <div v-if="confirm" class="card--alert">
          <h4 class="card--alert__title">{{ $t('Common.attention') }}</h4>
          <p class="card--alert__text">{{ $t(`${namespace}.messageAlert`) }}</p>
        </div>
      </div>
    </div>

    <div v-if="confirm">
      <v-divider />

      <div class="pt-4 pb-3">
        <div class="text-xs-center">
          <v-btn
            color="accent"
            depressed
            round
            @click="handleEditProject"
          >
            {{ $t('Common.proceed') }}
          </v-btn>
        </div>

        <div class="text-xs-center mt-3">
          <a class="accent--text" @click.prevent="close">
            {{ $t('Common.cancel') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calcContentHeight } from 'utils/functions'

export default {
  name: 'Preview',
  props: {
    paymentMethod: {
      type: String
    },
    data: {
      type: Object
    },
    confirm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.paymentMethod.body',
      contentHeight: 'none'
    }
  },
  methods: {
    calcContentHeight () {
      this.contentHeight = `${calcContentHeight() - 125}px`
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    close () {
      this.$emit('close')
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
$padding-a: 24px;

.credit-card {
  background-position: center;
  background-repeat: no-repeat;
  height: 190px;
  margin: 0 auto;
  padding: $padding-a;
  position: relative;
  width: 325px;

  &:before {
    background-color: rgba($gray-7, 0.9);
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: all .26s;
  }
}

.card--overlay {
  position: relative;

  &:before {
    opacity: 1;
    visibility: visible;
  }
}

.card--yellow {
  background-image: url('~@/assets/img/credit-card-yellow.svg');
}

.card--transfer {
  background-image: url('~@/assets/img/img-transfer.svg');
}

.card--billet {
  background-image: url('~@/assets/img/img-billet.svg');
}

.card__name {
  font-weight: 600;
}

.card--footer {
  bottom: $padding-a;
  left: $padding-a;
  right: $padding-a;
  position: absolute;
}

.card__number,
.card__flag {
  display: inline-block;
  vertical-align: middle;
}

.card__number {
  display: block;
  font-weight: 600;
  font-size: 19px;
}

.card__flag {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  height: 40px;
  position: absolute;
  right: 0;
  transform: translateY(-50%);
  top: 50%;
  width: 60px;
}

.card__amex {

  .card__flag {
    background-image: url('~@/assets/img/credit-card-flags/amex.svg');
    background-size: 70%;
  }
}

.card__diners {

  .card__flag {
    background-image: url('~@/assets/img/credit-card-flags/diners.svg');
  }
}

.card__elo {

  .card__flag {
    background-image: url('~@/assets/img/credit-card-flags/elo.svg');
  }
}

.card__hipercard {

  .card__flag {
    background-image: url('~@/assets/img/credit-card-flags/hipercard.svg');
  }
}

.card__mastercard {

  .card__flag {
    background-image: url('~@/assets/img/credit-card-flags/master-card.svg');
  }
}

.card__visa {

  .card__flag {
    background-image: url('~@/assets/img/credit-card-flags/visa.svg');
  }
}

.card--alert {
  bottom: 0;
  color: #fff;
  left: $padding-a;
  position: absolute;
  right: $padding-a;
  top: $padding-a;
  z-index: 1;
}

.financial-drawer-content {
  overflow-x: initial;
  overflow-y: auto;
}
</style>
